import { ListOfCalendarGroupResponse } from './Api/ListOfCalendarGroupResponse';

export class CalendarGroupEntity extends ListOfCalendarGroupResponse {
	public static tryCast(o: any) {
		const ret = new CalendarGroupEntity();
		return Object.assign(ret, o);
	}
}
